<template>
    <div class="maintenance">
        <header>
            <img loading="lazy" src="../../assets/Chery-Slider-Image-1.webp" alt="banner img">
        </header>

        <div class="container">
            
            <h1>Request for Maintenance Appointment</h1>

            <div class="block">
                <div v-if="theRes.length != 0" style="width: 100%;
                            border-radius: 10px;
                            padding: 1.2em;
                            text-transform: capitalize;
                            background: var(--noble-gold2);
                            border: 2px solid var(--noble-gold);
                            color: var(--tech-black);
                            display: flex;
                            align-items: center;
                            justify-content: space-between;">
                    {{ theRes }}

                    <button style="color: var(--tech-black);" @click="theRes=''">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </button>
                 </div>
                <!-- personal details -->
                <div class="form">
                    <!-- username -->
                    <div>
                        <label class="title" for="username">Full Name</label>
                        <input v-model="name" id="username" type="text" placeholder="Full name">
                        <span class="errorTxt" v-if="errors.name.length>1">{{ errors.name }}</span>
                    </div>

                    <!-- email -->
                    <div>
                        <label class="title" for="email">Email</label>
                        <input v-model="email" type="email" placeholder="example@xyz.com">
                        <span class="errorTxt" v-if="errors.email.length>1">{{ errors.email }}</span>
                    </div>

                    <!-- phone -->
                    <div>
                        <label class="title" for="phone">Phone Number</label>
                        <input v-model="phone" type="text" placeholder="+218-9x-xxxxxxx">
                        <span class="errorTxt" v-if="errors.phone.length>1">{{ errors.phone }}</span>
                    </div>

                    <!-- city -->
                    <div>
                        <label class="title">Select a city for test drive</label>
                        
                        <div class="selected" @click="cityMenu= !cityMenu; carMenu=false">
                            {{ selectedCity }}
                            <svg :style="{transform: cityMenu ? 'rotate(180deg)':'rotate(0deg)'}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                        </div>
                        <span class="errorTxt" v-if="errors.city.length>1">{{ errors.city }}</span>

                        <transition name="slide" mode="out-in" appear>
                            <div class="menu" v-if="cityMenu">
                                <span v-for="city in cities" :key="city.value" @click="selectedCity=city.value; cityMenu=false">{{ city.name }}</span>
                            </div>
                        </transition>
                    </div>

                </div>

                <!-- location and date -->
                <div class="form">
                    <div>
                        <label class="title">Distance Traveled</label>
                        <input v-model="dist" type="number" min="0" placeholder="">
                        <span class="errorTxt" v-if="errors.dist.length>1">{{ errors.dist }}</span>
                    </div>

                    <!-- date -->
                    <div>
                        <label class="title">Requested Booking Date</label>
                        <date-picker format="YYYY-MM-DD"
                                    placeholder="Select date" 
                                    v-model="time1" 
                                    valueType="format" 
                                    input-class="my-date-input"></date-picker>
                        <span class="errorTxt" v-if="errors.date.length>1">{{ errors.date }}</span>
                    </div>
                </div>
                
                <!-- select a car -->
                <div class="form">
                    <!-- car year model -->
                    <div>
                        <label class="title">car model</label>
                        <input v-model="model" type="number" min="2010" max="2025" placeholder="Enter model 2000 - 2025">
                        <span class="errorTxt" v-if="errors.model.length>1">{{ errors.model }}</span>
                    </div>

                    <!-- vehicle type -->
                    <div>
                        <label class="title">Select a city for test drive</label>
                        
                        <div class="selected" @click="carMenu= !carMenu; cityMenu=false">
                            {{ selectedCar }}
                            <svg :style="{transform: carMenu ? 'rotate(180deg)':'rotate(0deg)'}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                        </div>
                        <span class="errorTxt" v-if="errors.vehicalType.length>1">{{ errors.vehicalType }}</span>

                        <transition name="slide" mode="out-in" appear>
                            <div class="menu" v-if="carMenu">
                                <span v-for="(car, index) in cars" :key="index" @click="selectedCar=car.value; carMenu=false">{{ car.name }}</span>
                            </div>
                        </transition>
                    </div>
                </div>

                <!-- textarea  -->
                <div class="form" style="grid-template-columns: 1fr; width: 100%;">
                    <div>
                        <textarea v-model="msg" placeholder="Please describe the issue or problem you are facing."></textarea>
                        <span class="errorTxt" v-if="errors.msg.length>1">{{ errors.msg }}</span>
                    </div>
                </div>

            </div>

            <div class="cta">
                <div class="g-recaptcha" 
                    data-callback="onCaptchaVerified"
                    data-expired-callback="onCaptchaExpired"
                    data-sitekey="6LezQ64nAAAAABJ_1jDbMwjTWn07462potaAZN16"></div>

                <button class="square" @click="sendMaintenance()">submit</button>
            </div>
            <span style="color: red;" class="errorTxt" v-if="errors.captcha.length>1">{{ errors.captcha }}</span>
        </div>
        
    </div>
</template>

<script>
/* global grecaptcha */
    import api from '@/apis';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    export default {
        components: { DatePicker },
        data() {
            return {
                captchaToken: "", // store token here
                recaptchaWidgetId: null,
                name: "",
                phone: "",
                email: "",
                msg: "",
                model: "", // the year of creation the car
                dist: "", // distance
                vehicalType: "", // deprecated - using cars array now
                errors: {
                    name: "",
                    phone: "",
                    email: "",
                    model: "", // the year of creation the car
                    date: "",
                    city: "",
                    dist: "",
                    msg: "",
                    vehicalType: "",
                    captcha: ""
                },
                theRes: "",

                time1: null,
                selectedCity: "Select a city",
                selectedCar: "Select a car",
                carMenu: false,
                cityMenu: false,
                cities: [],
                cars: []
            }
        },
        methods: {
            fetchCities() {
                api.get("/cities")
                .then(res => {
                    this.cities = res.data.data;
                })
                .catch(err => {
                    console.log(err);
                    
                })
            },
            fetchCarsNames() {
                // /api/models/names
                api.get("/models/names")
                .then(res => {
                    this.cars = res.data.data;
                })
                .catch(err => {
                    console.log(err);
                    
                })
            },
            validateForm() {
                // Reset errors first
                this.errors.name = "";
                this.errors.phone = "";
                this.errors.email = "";
                this.errors.model = "";
                this.errors.city = "";
                this.errors.date = "";
                this.errors.dist = "";
                this.errors.msg = "";
                this.errors.vehicalType = "";

                let isValid = true;

                // ---------- NAME ----------
                if (!this.name.trim()) {
                    this.errors.name = "Name is required";
                    isValid = false;
                } else if (this.name.length < 3) {
                    this.errors.name = "Name must be at least 3 characters";
                    isValid = false;
                } else if (this.name.length > 255) {
                    this.errors.name = "Name cannot exceed 255 characters";
                    isValid = false;
                }

                // ---------- PHONE ----------
                const phoneRegex = /^[0-9]{9,15}$/;
                const phoneClean = this.phone.replace(/^\+/, "");
                if (!phoneClean) {
                    this.errors.phone = "Phone is required";
                    isValid = false;
                } else if (!phoneRegex.test(phoneClean)) {
                    this.errors.phone = "Phone must be 9–15 digits";
                    isValid = false;
                }

                // ---------- EMAIL ----------
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                if (!this.email.trim()) {
                    this.errors.email = "Email is required";
                    isValid = false;
                } else if (this.email.length < 6) {
                    this.errors.email = "Email must be at least 6 characters";
                    isValid = false;
                } else if (this.email.length > 255) {
                    this.errors.email = "Email cannot exceed 255 characters";
                    isValid = false;
                } else if (!emailRegex.test(this.email)) {
                    this.errors.email = "Invalid email format";
                    isValid = false;
                }

                // ---------- MODEL YEAR ----------
                const modelYear = Number(this.model);
                if (!this.model.trim()) {
                    this.errors.model = "Model year is required";
                    isValid = false;
                } else if (isNaN(modelYear)) {
                    this.errors.model = "Model year must be a number";
                    isValid = false;
                } else if (modelYear < 2010 || modelYear > 2025) {
                    this.errors.model = "Model year must be between 2010 and 2025";
                    isValid = false;
                }

                // ---------- VEHICLE MODEL ----------
                const vehicleRegex = /^[A-Za-z0-9_-]+(\s?[A-Za-z0-9_-]+)*$/; // letters, numbers, spaces, underscores, hyphens
                if (!this.selectedCar || this.selectedCar.trim() == "" || this.selectedCar == "Select a car") {
                    this.errors.vehicalType = "Vehicle model is required";
                    isValid = false;
                } else if (!vehicleRegex.test(this.selectedCar)) {
                    this.errors.vehicalType = "Vehicle model is invalid";
                    isValid = false;
                }

                // ---------- CITY ----------
                const cityRegex = /^[A-Za-z\s-]{2,100}$/; 
                if (!this.selectedCity || this.selectedCity == "Select a city") {
                    this.errors.city = "City is required";
                    isValid = false;
                } else if (!cityRegex.test(this.selectedCity)) {
                    this.errors.city = "City name is invalid";
                    isValid = false;
                }

                // ---------- DISTANCE ----------
                const distNumber = Number(this.dist);
                if (!this.dist) {
                    this.errors.dist = "Distance is required";
                    isValid = false;
                } else if (isNaN(distNumber)) {
                    this.errors.dist = "Distance must be numeric";
                    isValid = false;
                } else if (distNumber < 0) {
                    this.errors.dist = "Distance cannot be negative";
                    isValid = false;
                } else if (distNumber > 1000000) {
                    this.errors.dist = "Distance cannot exceed 1,000,000";
                    isValid = false;
                }

                // ---------- DATE / TIME ----------
                if (!this.time1) {
                    this.errors.date = "Date is required";
                    isValid = false;
                } else if (isNaN(Date.parse(this.time1))) {
                    this.errors.date = "Invalid date format";
                    isValid = false;
                }

                // ---------- MESSAGE ----------
                if (!this.msg.trim()) {
                    this.errors.msg = "Message is required";
                    isValid = false;
                } else if (this.msg.length < 10) {
                    this.errors.msg = "Message must be at least 10 characters";
                    isValid = false;
                } else if (this.msg.length > 50000) {
                    this.errors.msg = "Message cannot exceed 50,000 characters";
                    isValid = false;
                }

                // Return final validation result
                return isValid;

                
            },
            sendMaintenance() {
                this.errors.captcha = "";

                if (!this.validateForm()) {return;}
                if (!this.captchaToken) {
                    this.errors.captcha = "Please complete the captcha.";
                    return;
                }

                api.post('/request_maintenance?locale=en', {
                    name: this.name,
                    phone: this.phone.replace(/^\+/, ''),
                    model: this.selectedCar,
                    year: this.model,
                    city: this.selectedCity,
                    distance: this.dist,
                    date: this.time1,
                    email: this.email,
                    message: this.msg,
                    'g-recaptcha-response': this.captchaToken // <-- this is critical
                    
                })
                .then(res => {
                    this.theRes = res.data.message;
                    
                    this.name = "";
                    this.phone = "";
                    this.selectedCar = "";
                    this.model = "";
                    this.selectedCity = "";
                    this.dist = "";
                    this.time1 = "";
                    this.email = "";
                    this.msg = "";
                    // ✅ Safely reset reCAPTCHA — only if available
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
                        // For auto-rendered reCAPTCHA with single widget, reset with no ID
                        grecaptcha.reset();
                        this.captchaToken = null;
                    }
                    
                })
                
                .catch(error => {
                    // console.log(error);
                    // ✅ Safely reset reCAPTCHA — only if available
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
                        // For auto-rendered reCAPTCHA with single widget, reset with no ID
                        grecaptcha.reset();
                        this.captchaToken = null;
                    }

                    // GLOBAL GUARD: only handle validation errors (422) with proper data
                    if (!error.response ||
                        error.response.status !== 422 ||
                        !error.response.data ||
                        !error.response.data.errors) {
                        // not a validation error → ignore field mapping
                        return;
                    }

                    const backendErrors = error.response.data.errors;

                    // Reset errors first
                    this.errors.name = "";
                    this.errors.phone = "";
                    this.errors.email = "";
                    this.errors.model = "";
                    this.errors.city = "";
                    this.errors.date = "";
                    this.errors.dist = "";
                    this.errors.msg = "";
                    this.errors.vehicalType = "";

                    // map backend errors safely
                    Object.keys(this.errors).forEach(field => {
                        if (backendErrors[field]) {
                        this.errors[field] = backendErrors[field][0];
                        }
                    });
                });


            }
        },
        mounted() {
            this.fetchCities();
            this.fetchCarsNames();
            // reCAPTCHA calls these global functions
            window.onCaptchaVerified = (token) => {
                this.captchaToken = token;
                console.log("✅ CAPTCHA verified:", token);
            };

            window.onCaptchaExpired = () => {
                this.captchaToken = null;
                // console.log("⚠️ CAPTCHA expired");
            };
        },
        beforeDestroy() {
            // Clean up to avoid memory leaks
            delete window.onCaptchaVerified;
            delete window.onCaptchaExpired;
        },
    }
</script>